// Libs
import React, { useState } from 'react';
import { useMutation, useQuery } from '@apollo/client';
import styled from 'styled-components';

// Components
import AdminModal from '../AdminModal';
import { Button, Flexbox, SearchableSingleSelect } from '@ibinder/common-frontend';

// Queries
import { GET_ALL_ORGS, GET_ORG_ID, MOVE_BINDER_TO_ORG } from '../../../../../../api/queries/queries_local';

const ModalWrapper = styled.div`
  padding: 1rem;
  height: 100%;
  overflow-x: auto;
`;
const Header = styled.p`
  margin-top: 1rem;
  margin-bottom: 1rem;
  span {
    font-weight: 700;
  }
`;
const BottomActionBar = styled(Flexbox)`
  margin-top: auto;
  box-shadow: ${(p) => p.theme.shadows.primaryWithOpacity};
  padding: 1rem;
`;
const ErrorMessage = styled.p`
  margin: 1rem 0;
  color: ${(p) => p.theme.colors.error};
  font-weight: 700;
`;
const InformationBox = styled.div`
  padding: 0.5rem 0;
  margin: 1rem 0;
  color: ${(p) => p.theme.colors.success};
  span {
    font-weight: 700;
  }
`;

const ChangeOrganizationModal = ({
  onClose,
  data,
  selectedIds = [],
  orgId
}) => {

  const [selectedValue, setSelectedValue] = useState(null);
  const [activeIndex, setActiveIndex] = useState(undefined);
  const [moveBinderIsLoading, setMoveBinderIsLoading] = useState(undefined);
  const [isError, setIsError] = useState(undefined);

  const getAllOrgs = useQuery(GET_ALL_ORGS);
  
  const getOrg = useQuery(GET_ORG_ID, {
    variables: { id: orgId }
  })

  const organizationData = getAllOrgs.data && getAllOrgs.data.get; 
  const currentOrganization = getOrg.data?.getOrg;
  const binderType = data.find((d) => d.binder.id === selectedIds[0]).binder.type;
  const theNewOrg = organizationData?.find((e) => e.id === selectedValue)?.name

  const [moveBinderToOrg] = useMutation(MOVE_BINDER_TO_ORG, {
    onCompleted: () => {
      setMoveBinderIsLoading(false);
    },
    onError: () => {
      setIsError(true);
      setMoveBinderIsLoading(undefined);
    }
  });

  const resetForm = () => {
    setSelectedValue(null);
    setMoveBinderIsLoading(undefined);
  };
  const onCloseModal = () => {
    onClose();
    resetForm();
  };

  const getNewOrganization = (index) => {
    setSelectedValue(index)
    setActiveIndex(index)
  }

  const changeOrganization = () => {
    setMoveBinderIsLoading(true);
    moveBinderToOrg(
      {
        variables: {
          body: {
            tenantId: currentOrganization?.id,
            binderId: selectedIds[0],
            newTenantId: selectedValue
          }
        }
      }
    )
  }   

  return (
    <AdminModal
      onClose={onCloseModal}
      label="Change organization"
      name="Change organization"
      Component={() => (
        <>
        <ModalWrapper>
         <Header>This binder is connected to organization 
           <span>
            {' '}{currentOrganization?.name}
           </span>
          </Header>

          {binderType === "Organization" && 
            <ErrorMessage>You can not move the binder if the type is Organization</ErrorMessage>
          }
          {isError && 
            <ErrorMessage>Something went wrong! Please contact 2ndline.</ErrorMessage>
          }
          {moveBinderIsLoading &&
            <InformationBox>
              <p>
                <span>Moving the binder..</span>
              </p>
            </InformationBox>
            }
            {moveBinderIsLoading === false && 
              <InformationBox>
                <p>Success! The binder is moved from <span>{currentOrganization?.name}</span> to <span>{theNewOrg}.</span></p>
              </InformationBox>
            }

          <SearchableSingleSelect 
            label="Select the organization to move the binder to."
            activeKey={activeIndex}
            loading={organizationData === undefined}
            dropdownText="Select organization"
            changeActiveItem={(index) => getNewOrganization(index)}
            data={organizationData?.map((o) => ({
              Value: o.name,
              Key: o.id
            }))}
          /> 

        </ModalWrapper>
        <BottomActionBar justifyContent="space-between">
          <Button
            onClick={onClose}
            label="Close"
            btnStyle="secondary"
            btnExtras={['labelWidth']}
          />
          <Button
            label={moveBinderIsLoading === false ? "Done" : "Change organization"}
            onClick={() => moveBinderIsLoading === false ? onClose() : changeOrganization()} 
            btnStyle="primary"
            btnExtras={['labelWidth']}
            disabled={!selectedValue || binderType === "Organization"}
          />
        </BottomActionBar>
        </>
      )}
    />
  );
};

export default ChangeOrganizationModal;
